
import { FSharpException } from "./fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { class_type } from "./fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { captureException, reportHttpError } from "./Sentry.js";
import { Exception } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { SessionExpired } from "./Auth.js";
import { RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ofArray } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { toast } from "react-hot-toast";
import { toFloat64 } from "./fable_modules/fable-library-js.5.0.0-rc.2/BigInt.js";
import { maxRequestBodySizeInBytes } from "./Shared/File.js";

export class Exception400 extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function Exception400_$reflection() {
    return class_type("ErrorHandling.Exception400", undefined, Exception400, class_type("System.Exception"));
}

export class Exception401 extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function Exception401_$reflection() {
    return class_type("ErrorHandling.Exception401", undefined, Exception401, class_type("System.Exception"));
}

export class Exception403 extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function Exception403_$reflection() {
    return class_type("ErrorHandling.Exception403", undefined, Exception403, class_type("System.Exception"));
}

export class Exception404 extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function Exception404_$reflection() {
    return class_type("ErrorHandling.Exception404", undefined, Exception404, class_type("System.Exception"));
}

export class Exception500 extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function Exception500_$reflection() {
    return class_type("ErrorHandling.Exception500", undefined, Exception500, class_type("System.Exception"));
}

export class Exception413 extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function Exception413_$reflection() {
    return class_type("ErrorHandling.Exception413", undefined, Exception413, class_type("System.Exception"));
}

export class CouldNotParseValidation extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function CouldNotParseValidation_$reflection() {
    return class_type("ErrorHandling.CouldNotParseValidation", undefined, CouldNotParseValidation, class_type("System.Exception"));
}

export class UnexpectedResponseCode extends FSharpException {
    constructor(Data0, Data1) {
        super();
        this.Data0 = (Data0 | 0);
        this.Data1 = Data1;
    }
}

export function UnexpectedResponseCode_$reflection() {
    return class_type("ErrorHandling.UnexpectedResponseCode", undefined, UnexpectedResponseCode, class_type("System.Exception"));
}

export class NotImplementedResponse extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function NotImplementedResponse_$reflection() {
    return class_type("ErrorHandling.NotImplementedResponse", undefined, NotImplementedResponse, class_type("System.Exception"));
}

export class ValidationOnGetRequest extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function ValidationOnGetRequest_$reflection() {
    return class_type("ErrorHandling.ValidationOnGetRequest", undefined, ValidationOnGetRequest, class_type("System.Exception"));
}

export function httpException(status, url) {
    switch (status) {
        case 400: {
            reportHttpError(status, url, "error");
            return new Exception400(url);
        }
        case 401:
            return new Exception401(url);
        case 403: {
            reportHttpError(status, url, "warning");
            return new Exception403(url);
        }
        case 404: {
            reportHttpError(status, url, "warning");
            return new Exception404(url);
        }
        case 413:
            return new Exception413(url);
        case 500: {
            reportHttpError(status, url, "error");
            return new Exception500(url);
        }
        default:
            return new UnexpectedResponseCode(status, url);
    }
}

function reportUnexpectedError(e) {
    let matchResult;
    if (e instanceof Exception400) {
        matchResult = 0;
    }
    else if (e instanceof Exception401) {
        matchResult = 0;
    }
    else if (e instanceof Exception403) {
        matchResult = 0;
    }
    else if (e instanceof Exception404) {
        matchResult = 0;
    }
    else if (e instanceof Exception413) {
        matchResult = 0;
    }
    else if (e instanceof Exception500) {
        matchResult = 0;
    }
    else if (e instanceof SessionExpired) {
        matchResult = 0;
    }
    else if (e instanceof NotImplementedResponse) {
        matchResult = 0;
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            break;
        }
        case 1: {
            captureException(new Exception(e.message));
            break;
        }
    }
}

export function handleFetchError(e) {
    reportUnexpectedError(e);
    let matchResult;
    if (e instanceof Exception400) {
        matchResult = 0;
    }
    else if (e instanceof Exception401) {
        matchResult = 1;
    }
    else if (e instanceof SessionExpired) {
        matchResult = 1;
    }
    else if (e instanceof Exception403) {
        matchResult = 2;
    }
    else if (e instanceof Exception404) {
        matchResult = 3;
    }
    else if (e instanceof Exception500) {
        matchResult = 4;
    }
    else if (e instanceof Exception413) {
        matchResult = 5;
    }
    else {
        matchResult = 6;
    }
    switch (matchResult) {
        case 0: {
            RouterModule_nav(ofArray(["bad-request"]), 1, 1);
            break;
        }
        case 1: {
            RouterModule_nav(ofArray(["unauthorized"]), 1, 1);
            break;
        }
        case 2: {
            RouterModule_nav(ofArray(["forbidden"]), 1, 1);
            break;
        }
        case 3: {
            RouterModule_nav(ofArray(["not-found"]), 1, 1);
            break;
        }
        case 4: {
            RouterModule_nav(ofArray(["error"]), 1, 1);
            break;
        }
        case 5: {
            toast.error("general.file_too_large_limit");
            break;
        }
    }
    throw e;
}

export function handleFetchErrorWithoutErrorPage(e) {
    let matchResult;
    if (e instanceof Exception401) {
        matchResult = 0;
    }
    else if (e instanceof SessionExpired) {
        matchResult = 0;
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            handleFetchError(e);
            break;
        }
        case 1: {
            reportUnexpectedError(e);
            break;
        }
    }
    throw e;
}

export function ensureRequestBodySize(formData) {
    if ((Array.from(formData.values()).reduce((sum, value) => sum + (value instanceof Blob ? value.size : 0), 0)) > toFloat64(maxRequestBodySizeInBytes)) {
        handleFetchError(new Exception413(""));
    }
}

